import { TTableFilter } from "@app/core/types/response.type";

export interface TPolicyDocument {
  id: string;
  fileUri: string;
  fileName: string;
  document: string;
  type: string;
  insuredName: string;
  createdAt: string;
  blobUri: string;
  description: string | null;
  generationStatus: EDocumentGenerationStatus | null;
  previewUri: string | null;
}

export enum EDocumentGenerationStatus {
  Forming = "Forming",
  Completed = "Completed",
  Failed = "Failed",
  Pending = "Pending"
}

export interface TPolicyDocumentFilter {
  policyId?: string;
  invoiceId?: string;
}

export type TPolicyDocumentListFilter = TTableFilter<TPolicyDocumentFilter>;

export interface TBulkCancelSigningItemResult {
  policyVersionId: string;
  isCancelled: boolean;
  errorMessage: string | null;
}

export interface TBulkCancelSigningResult {
  totalRequested: number;
  cancelledCount: number;
  failedCount: number;
  results: TBulkCancelSigningItemResult[];
}
